module.exports = __webpack_public_path__ + "img/VRC-alt.2c377a2f.svg";